import Vue from 'vue'
import Router from 'vue-router'
import List from '@/components/List'
import HotProduct from '@/components/HotProduct'
import NewProduct from '@/components/NewProduct'
import NewDiscount from '@/components/NewDiscount'
// 《3A医药城隐私政策》
import Explain from '@/components/Explain'
// 《3A医药城用户协议》
import MyExplain from '@/components/MyExplain'
//3A医药城免责声明
import Disclaimer from '@/components/Disclaimer'
// 3A医药城与3A医药城用户， 禁止网络销售协议书
import BannedAgreement from '@/components/BannedAgreement'

// 《药百万隐私政策》
import WYExplain from '@/components/WYExplain'
//药百万用户协议
import WYMyExplain from '@/components/WYMyExplain'
//药百万与药百万用户， 禁止网络销售协议书
import WYBannedAgreement from '@/components/WYBannedAgreement'
//药百万 免责声明
import WYDisclaimer from '@/components/WYDisclaimer'


// 复盛公药房隐私政
import DYFExplain from '@/components/DYFExplain'
// 复盛公药房用户协议
import DYFMyExplain from '@/components/DYFMyExplain'
// 复盛公药房免责声明
import DYFDisclaimer from '@/components/DYFDisclaimer'
//复盛公药房， 禁止网络销售协议书
import  DYFBannedAgreement from '@/components/DYFBannedAgreement'




// 医生帮隐私政
import YSBExplain from '@/components/YSBExplain'
// 医生帮用户协议
import YSBMyExplain from '@/components/YSBMyExplain'
// 医生帮免责声明
import YSBDisclaimer from '@/components/YSBDisclaimer'
//医生帮， 禁止网络销售协议书
import  YSBBannedAgreement from '@/components/YSBBannedAgreement'




// 欢迎您使用新宝药(以下简称“本服务”)
import BYTExplain from '@/components/BYTExplain'
// 复盛公医药网用户服务协议
import YYExplain from '@/components/YYExplain'

// 我的授信使用说明
import CreditInstructions from '@/components/CreditInstructions'
// 飞贷业务介绍
import FlyLoans from '@/components/FlyLoans'
// 飞贷申请
import FlyloanData from '@/components/FlyloanData'
//飞贷 返利卡说明
import RebateDes  from '@/components/RebateDes'


import Activity from '@/components/Activity'

import SmashEggs from '@/components/SmashEggs'
// 618专题活动页
import TopicPage  from '@/components/TopicPage'

// 成长值规则
import MemberLevelPage  from '@/components/MemberLevelPage'

Vue.use(Router)

export default new Router({
  routes: [{
      path: '/',
      name: 'List',
      component: List
    },
    // 禁止网络销售协议书
    {
      path: '/bannedAgreement',
      name: 'BannedAgreement',
      component: BannedAgreement
    },
    
    {
      path: '/dyfBannedAgreement',
      name: 'DYFBannedAgreement',
      component: DYFBannedAgreement
    },
     // 禁止网络销售协议书
     {
      path: '/wybannedAgreement',
      name: 'WYBannedAgreement',
      component: WYBannedAgreement
    },
    // 返利说明 RebateDes
    {
      path: '/rebateDes',
      name: 'RebateDes',
      component: RebateDes
    },
    {
      path: '/flyloanData',
      name: 'FlyloanData',
      component: FlyloanData
    },
    {
      path: '/smashEggs',
      name: 'SmashEggs',
      component: SmashEggs
    },
    {
      path: '/wYdisclaimer',
      name: 'WYDisclaimer',
      component: WYDisclaimer
    },
    {
      path: '/disclaimer',
      name: 'Disclaimer',
      component: Disclaimer
    },
    
    {
      path: '/dyfDisclaimer',
      name: 'DYFDisclaimer',
      component: DYFDisclaimer
    },
    {
      path: '/creditInstructions',
      name: 'CreditInstructions',
      component: CreditInstructions
    },
    {
      path: '/flyLoans',
      name: 'FlyLoans',
      component: FlyLoans
    },
    {
      path: '/yyexplain',
      name: 'YYExplain',
      component: YYExplain
    },
    {
      path: '/wyexplain',
      name: 'WYExplain',
      component: WYExplain
    },
    
    {
      path: '/wyMyExplain',
      name: 'WYMyExplain',
      component: WYMyExplain
    },
    {
      path: '/explain',
      name: 'Explain',
      component: Explain
    },
    
    {
      path: '/myexplain',
      name: 'MyExplain',
      component: MyExplain
    },
    
    {
      path: '/dyfMyExplain',
      name: 'DYFMyExplain',
      component: DYFMyExplain
    },
    {
      path: '/dyfExplain',
      name: 'DYFExplain',
      component: DYFExplain
    },

    {
      path: '/ysbExplain',//医生帮隐私政策
      name: 'YSBExplain',
      component: YSBExplain
    },
    {
      path: '/ysbMyExplain',//医生帮用户协议
      name: 'YSBMyExplain',
      component: YSBMyExplain
    },
    {
      path: '/ysbDisclaimer',//医生帮免责声明
      name: 'YSBDisclaimer',
      component: YSBDisclaimer
    },
    {
      path: '/ysbBannedAgreement',//医生帮， 禁止网络销售协议书
      name: 'YSBBannedAgreement',
      component: YSBBannedAgreement
    },
    {
      path: '/bytexplain',
      name: 'BYTExplain',
      component: BYTExplain
    },
    {
      path: '/hotProduct',
      name: 'HotProduct',
      component: HotProduct
    },

    //618活动专题页 TopicPage
    {
      path: '/topicPage',
      name: 'TopicPage',
      component: TopicPage
    },

    
    // 成长值规则
    {
      path: '/memberLevelPage',
      name: 'MemberLevelPage',
      component: MemberLevelPage
    },

    {
      path: '/newProduct',
      name: 'NewProduct',
      component: NewProduct
    },
    {
      path: '/newDiscount',
      name: 'NewDiscount',
      component: NewDiscount
    },
    {
      path: '/activity',
      name: 'Activity',
      component: Activity
    },
    //砸金蛋import HitGoldEgg from '@/components/HitGoldEgg'
    {
      path: '/hitGoldEgg',
      name: 'HitGoldEgg',
      component: () => import('@/components/pageLi/HitGoldEgg')
    },
    //积分规则
    {
      path: '/integralRule',
      name: 'IntegralRule',
      component: () => import('@/components/IntegralRule')
    },

    //丸药积分规则
    {
      path: '/wyintegralRule',
      name: 'wyIntegralRule',
      component: () => import('@/components/WYIntegralRule')
    },
    //一元购
    {
      path: '/buyOneYuan',
      name: 'buyOneYuan',
      component: () => import('@/components/pageLi/BuyOneYuan')
    },

    //代付
    {
      path: '/PayAnother',
      name: 'PayAnother',
      component: () => import('@/components/PayAnother')
    },


    //一元购
    {
      path: '/NewGameRule',
      name: 'NewGameRule',
      component: () => import('@/components/NewGameRule')
    },

  ]
})












// WEBPACK FOOTER //
// ./src/router/index.js